import { IBreadcrumbItem } from "office-ui-fabric-react/lib/Breadcrumb";

export enum BreadCrumbsActiontypes {
    UPDATE = 'UPDATE'
}
export interface IBreadCrumbsAction {
    type: BreadCrumbsActiontypes.UPDATE;
    payload: { items: IBreadcrumbItem[] };
}
